import { ButtonWithArrowRight, Footer, Title } from '~components';
import { useTransshipment } from '~contexts/TranshipmentContext';
import * as Styled from './styled';
import * as amplitude from '@amplitude/analytics-browser';
import { useEffect } from 'react';

function DocumentsCaptured() {
  const transhipment = useTransshipment();
  const { data, type } = useTransshipment();

  useEffect(() => {
    if (type === 'representative') {
      amplitude.track({
        event_type: 'documentation_sent_completed',
        event_properties: {
          CPF_representatives: data.cpf,
        },
      });
    }
  }, []);

  function handleOnClickNext() {
    transhipment.nextStep();
  }

  return (
    <Styled.Container>
      <Styled.Content>
        <Title id="form-document-type-title">
          Tudo certo com a captura dos documentos!
        </Title>
        <Styled.MenShowingSuccess />
        <Styled.Description variant="sub500">
          Todos os dados e documentos serão analisados internamente pela
          FreteBras.
        </Styled.Description>
      </Styled.Content>
      <Footer
        marginTop="auto"
        rightButton={
          <ButtonWithArrowRight
            width="100%"
            onClick={handleOnClickNext}
            variant="primary"
          >
            Continuar
          </ButtonWithArrowRight>
        }
      />
    </Styled.Container>
  );
}

export default DocumentsCaptured;
